import React, { useContext, useReducer, createContext } from 'react'
import reducer, { defaultInitialState } from './FullNameReducer'

export const FullNameStateContext = createContext(null)
export const FullNameDispatchContext = createContext(null)

export default function FullNameContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, defaultInitialState)

  return (
    <FullNameStateContext.Provider value={state}>
      <FullNameDispatchContext.Provider value={dispatch}>{children}</FullNameDispatchContext.Provider>
    </FullNameStateContext.Provider>
  )
}

export const useFullNameStateContext = () => {
  const context = useContext(FullNameStateContext)
  if (!context) {
    throw new Error(
      'useFullNameStateContext must be used within a FullNameContextProvider. If writing a test, use <StateProvider> from testUtils.js'
    )
  }
  return context
}
export const useFullNameDispatchContext = () => {
  const context = useContext(FullNameDispatchContext)
  if (!context) {
    throw new Error(
      'useFullNameDispatchContext must be used within a FullNameContextProvider. If writing a test, use <StateProvider> from testUtils.js'
    )
  }
  return context
}
